import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { FormControl, FormGroup } from '@angular/forms';
import { IPerson, IPersonFormResponseApi, IPersonListResponseApi, IPersonSingleResponseApi } from 'src/app/interfaces/person/person.interface';

@Injectable({
  providedIn: 'root'
})
export class PersonService {
  private readonly http = inject(HttpClient);

  formFilterList = new FormGroup({
    personType: new FormControl(''),
    searchType: new FormControl(''),
    searchText: new FormControl(''),
    status: new FormControl(''),
    page: new FormControl(1),
    pageSize: new FormControl(5),
    sortBy: new FormControl(''),
    sortOrder: new FormControl(''),
  });

  listAll(payload: {
    pageSize: number;
    page: number;
    status?: string;
    searchType?: string;
    personType?: string;
    searchText?: string;
    sortBy?: string;
    sortOrder?: string;
  }) {
    let params = new HttpParams()
      .set('page', payload.page)
      .set('pageSize', payload.pageSize);

    if (payload.status) {
      params = params.set('status', payload.status);
    }

    if (payload.searchType) {
      params = params.set('searchType', payload.searchType);
    }

    if (payload.personType) {
      params = params.set('personType', payload.personType);
    }

    if (payload.searchText) {
      params = params.set('searchText', payload.searchText);
    }

    if (payload.sortBy) {
      params = params.set('sortBy', payload.sortBy);
    }

    if (payload.sortOrder) {
      params = params.set('sortOrder', payload.sortOrder);
    }

    return this.http.get<IPersonListResponseApi>(
      `${environment.api}/person/all`, { params }
    );
  }

  export(payload: {
    status?: string;
    searchType?: string;
    personType?: string;
    searchText?: string;
    sortBy?: string;
    sortOrder?: string;
  }) {
    let params = new HttpParams();

    if (payload.status) {
      params = params.set('status', payload.status);
    }

    if (payload.searchType) {
      params = params.set('searchType', payload.searchType);
    }

    if (payload.personType) {
      params = params.set('personType', payload.personType);
    }

    if (payload.searchText) {
      params = params.set('searchText', payload.searchText);
    }

    if (payload.sortBy) {
      params = params.set('sortBy', payload.sortBy);
    }

    if (payload.sortOrder) {
      params = params.set('sortOrder', payload.sortOrder);
    }

    return this.http.get(
      `${environment.api}/person/all/export`,
      { params, responseType: 'blob' }
    );
  }

  register(body: IPerson) {
    if (body.id) {
      return this.update(body);
    } else {
      return this.create(body);
    }
  }

  create(body: IPerson) {
    return this.http.post<IPersonFormResponseApi>(`${environment.api}/person/create`, body);
  }

  update(body: IPerson) {
    return this.http.put<IPersonFormResponseApi>(`${environment.api}/person/update/${body.id}`, body);
  }

  delete(id: string) {
    return this.http.delete(`${environment.api}/person/delete/${id}`).pipe(
      (res) => res,
      (error) => error
    );
  }

  toggle(id: string, status: boolean) {
    return this.http.patch(`${environment.api}/person/${id}/change-status`, { status }).pipe(
      (res) => res,
      (error) => error
    );
  }

  getById(id: string) {
    return this.http.get<IPersonSingleResponseApi>(`${environment.api}/person/${id}`);
  }
}
